import examinationItemResultParser from './examinationItemResultParser';
import { ExaminationItemResultArray, ExaminationItemResult } from './types';

const mapExaminationItemResult = (
  data: ExaminationItemResultArray,
): ExaminationItemResultArray =>
  data.map(examinationItemResultParser);

export default mapExaminationItemResult;



// WEBPACK FOOTER //
// ./src/services/api/remoteedu/utils/mapExaminationItemResult.ts